<template>
  <div
    style="background: #ffffffb0; position: absolute; z-index: 1; top: 0; right: 15px; bottom: 0; left: 15px;"
  >
    <div style="position: absolute;left: 50%; top: 50%;margin-top: -12px; margin-left: -28.5px">
      <pulse-loader :color="$vuetify.theme.primary" :size="'15px'"></pulse-loader>
    </div>
  </div>
</template>

<script>
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
export default {
  components: {
    PulseLoader
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/DashboardGraphLoading.vue